import { BaseEditViewStore } from "core/stores";
import { NoteEditForm } from "application/tracking-case/forms";
import { NoteService } from "application/tracking-case/services";
import { action } from "mobx";

class NoteEditModalStore extends BaseEditViewStore {
    constructor(rootStore, componentProps) {
        const noteService = new NoteService(rootStore.application.baasic.apiClient);

        super(rootStore, {
            name: "note-edit",
            id: componentProps.modalParams.data.id,
            actions: {
                get: async id => {
                    const response = await noteService.get(id);
                    this.form.update(response.data);

                    return response.data;
                },
                update: async resource => {
                    resource.trackingCaseId = this.componentData.trackingCaseId;
                    const response = await noteService.update(resource);

                    return response.data;
                },
                create: async resource => {
                    resource.trackingCaseId = this.componentData.trackingCaseId;
                    const response = await noteService.create(resource);

                    return response.data;
                },
            },
            errorActions: {
                onCreateError: ({ error }) => {
                    rootStore.notificationStore.error('NOTE.CREATE.ERROR', error);
                },
                onUpdateError: ({ error }) => {
                    rootStore.notificationStore.error('NOTE.EDIT.ERROR', error);
                },
            },
            FormClass: NoteEditForm,
        });

        this.noteService = new NoteService(rootStore.application.baasic.apiClient);
        this.componentProps = componentProps;
        this.componentData = componentProps && componentProps.modalParams.data;
    }

    @action.bound
    async createResource(resource) {
        if (!this.actions.create) return;

        this.form.setFieldsDisabled(true);
        
        try {
            if (this.translationStore) {
                this.translationStore.applyMetadata(resource);
            }

            await this.actions.create(resource);

            if (this.componentData == null) {
                await this.rootStore.routerStore.goBack();
            }
            else
            {
                this.componentProps.modalParams.close();
                this.componentProps.modalParams.data.fetchTable();
            }

            await setTimeout(() => this.notifySuccessCreate(), 10);
        }
        catch(err) {
            this.form.setFieldsDisabled(false);
            return this.onCreateError(err);
        }
    }

    @action.bound
    async updateResource(resource) {
        if (!this.actions.update) return;

        this.form.setFieldsDisabled(true);
        
        try {
            if (this.translationStore) {
                this.translationStore.applyMetadata(resource);
            }

            await this.actions.update({
                id: this.id,
                ...resource
            });

            if (this.componentData == null) {
                await this.rootStore.routerStore.goBack();
            }
            else
            {
                this.componentProps.modalParams.close();
                this.componentProps.modalParams.data.fetchTable();
            }

            await setTimeout(() => this.notifySuccessUpdate(), 10);
        }
        catch(err) {
            this.form.setFieldsDisabled(false);
            return this.onUpdateError(err);
        }
    }
}

export default NoteEditModalStore;